import { createSlice } from "@reduxjs/toolkit";

export const editTransactionFormSlice = createSlice({
    name: 'editTransactionForm',
    initialState: {
        active: false,
        editTransactionId: "",
        description: "",
        transactionDate: "",
        amount: 0
    },
    reducers: {
        changeActive: (state, action) => {
            return {
                ...state,
                active: action.payload
            }
        },
        prefillForm: (state, action) => {
            const transactionDate = action.payload.transactionDate.split('T')[0]
            return {
                ...state,
                editTransactionId: action.payload.id,
                description: action.payload.description,
                transactionDate,
                amount: action.payload.amount
            }
        },
        changeDescription: (state, action) => {
            return {
                ...state,
                description: action.payload
            }
        },
        changeTransactionDate: (state, action) => {
            return {
                ...state,
                transactionDate: action.payload
            }
        },
        changeAmount: (state, action) => {
            return {
                ...state,
                amount: action.payload
            }
        },
        clearForm: (state) => {
            return {
                ...state,
                description: "",
                transactionDate: "",
                amount: 0
            }
        }
    }
})

export const isEditTransactionFormActive = (state) => state.editTransactionForm.active;
export const selectEditTransactionId = (state) => state.editTransactionForm.editTransactionId;
export const selectEditTransactionFormDescription = (state) => state.editTransactionForm.description;
export const selectEditTransactionFormTransactionDate = (state) => state.editTransactionForm.transactionDate;
export const selectEditTransactionFormAmount = (state) => state.editTransactionForm.amount;

export const { changeActive, prefillForm, changeDescription, changeTransactionDate, changeAmount, clearForm } = editTransactionFormSlice.actions;

export default editTransactionFormSlice.reducer;